import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { HTMLformat } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { MinifiedHTMLExample } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function HTMLFormatter() {
    const [text, setText] = useState("");
    const [beautifyReqBody, setBeautifyReqBody] = useState();
    const [minifyReqBody, setMinifyReqBody] = useState();
    const [result, setresult] = useState("")
    const indent = 2;
    const toolFav = { toolName: 'HTML Formatter', Iconpath: "/FileCodeRaw.svg" };
    const [activeAction, setActiveAction] = useState("minify");
    const [, setIsValid] = useState(true);


    

    


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
        setBeautifyReqBody({
            input: e.target.value,
            indent: indent
        });
        setMinifyReqBody({
            input: e.target.value
        });
    };


    const formatHTML= () => {
        if (activeAction === "minify") {
            MinifyHTML();
        }
        else {
            BeautifyHTML();
        }
    }

    const pasteExample = () => {
        if (activeAction === "minify") {
            setText(MinifiedHTMLExample);
            setMinifyReqBody({
                input: MinifiedHTMLExample,
            });
        }
        else {
            const exampleText = MinifiedHTMLExample;
            setText(exampleText);
            setBeautifyReqBody({
                input: exampleText,
                indent: indent
            });
        }
    };


    const handleImport = (filecontent) => {
        setText(filecontent);

        setBeautifyReqBody({
            input: filecontent,
            indent: indent
        });

        setMinifyReqBody({
            input: filecontent,
            indent: indent
        });

    };

    const MinifyHTML = async () => {
        try {
            const response = await HTMLformat(minifyReqBody);
            setresult(response.data.formattedHtml);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                const apiMessage =
                    error.response?.data?.message;
                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    const BeautifyHTML = async () => {
        try {
            const response = await HTMLformat(beautifyReqBody);
            setresult(response.data.formattedHtml);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400 || error.response?.status === 500) {
                const apiMessage =
                    error.response?.data?.message;

                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    const runAction = async (action) => {
        setActiveAction(action);
        setText("");
        setresult("");
    }
    return (
        <>
            <Col>
                <ToolHeader title="HTML Formatter" description="Format and validate HTML data" toolFav={toolFav} />

                <ToolActionButtons
                    actions={[
                        { label: "Minify", value: "minify" },
                        { label: "Beautify", value: "beautify" }
                    ]}
                    activeValue={activeAction}
                    onAction={(action) => runAction(action.value)}
                />

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input HTML"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your HTML here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setBeautifyReqBody("");
                                        setMinifyReqBody("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".html"
                                    executeLabel={"Format"}
                                    showExecute={true}
                                    onExecute={formatHTML}
                                />
                            }
                            footerLeft={`Characters : ${String(text ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text ?? ""]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Formatted HTML"
                            value={result ?? ""}
                            placeholder="Formatted HTML will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.html"
                                    mimeType="application/html;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${String(result ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default HTMLFormatter;
